import UtilityService from "@/services/UtilityService";
import ApiService from "./ApiService";
import store from "@/store";

const _WALLET_INSTRUMENT_TYPE = {
    SVA: "SVA",
    BANK_ACCOUNT: "BANK_ACCOUNT",
    PREPAID_CARD: "PREPAID_CARD",
    FINANCIAL_ACCOUNT: "FINANCIAL_ACCOUNT"
  },
  _CARD_STATES = {
    BLOCKED: "LOCKED",
    PENDING: "NEW",
    ENABLED: "ENABLED",
    EXPIRING: "EXPIRING"
  };

class WalletService {
  getStates() {
    return _CARD_STATES;
  }
  getTypes() {
    return _WALLET_INSTRUMENT_TYPE;
  }
  getWalletInstruments() {
    return UtilityService.cachedService({
      service: "/usr/v2/wallet-instruments",
      params: {
        returnBankAccount: true,
        returnDeletedAccount: true,
        returnFinancialAccount: true,
        returnPrepaidCard: true,
        returnSva: true
      },
      getNode: x => x.walletInstruments,
      storageKey: "cr_wi"
    });
  }

  getTransactions(req) {
    const params = {
      returnSva: true,
      returnFinancialAccount: true,
      returnDeletedAccount: true,
      returnBankAccount: true,
      returnPrepaidCard: true
    };

    return ApiService.get("/usr/v2/wallet-transactions", req || params);
  }

  getPrepaidCard() {
    let card;

    const cards = store.state.walletInstruments.filter(
      wallet =>
        wallet.walletInstrumentResource.walletInstrumentType === "PREPAID_CARD"
    );

    const cardEnabled = cards.filter(
      wallet => wallet.walletInstrumentResource.state === "ENABLED"
    );
    const cardNew = cards.filter(
      wallet => wallet.walletInstrumentResource.state === "NEW"
    );
    const cardLocked = cards.filter(
      wallet => wallet.walletInstrumentResource.state === "LOCKED"
    );
    const cardDeleted = cards.filter(
      wallet => wallet.walletInstrumentResource.state === "DELETED"
    );

    if (cardEnabled.length) {
      card = cardEnabled.pop();
    } else if (cardNew.length) {
      card = cardNew.pop();
    } else if (cardLocked.length) {
      card = cardLocked.pop();
    } else if (cardDeleted.length) {
      card = cardDeleted.pop();
    }

    return card;
  }

  getCardInfo(instrumentId) {
    if (!instrumentId) return;
    return ApiService.get(`/usr/v2/wallet-instruments/${instrumentId}/card-info`);
  }

  hasPrepaidCardWaitingForApproval() {
    const cards = store.state.walletInstruments.filter(
      wallet =>
        wallet.walletInstrumentResource.walletInstrumentType ===
          "PREPAID_CARD" && wallet.walletInstrumentResource.state === "NEW"
    );

    return cards.length > 0;
  }

  getBalance(instrumentId) {
    if (!instrumentId) return;
    return ApiService.get(`/usr/v2/wallet-instruments/${instrumentId}/balance`);
  }

  _all() {
    return JSON.parse(sessionStorage.getItem("cr_wi"));
  }

  getBankWalletInstrument() {
    if (!this._all()) {
      debugger;
    }
    return this._all().filter(
      i =>
        i.walletInstrumentResource.primaryInstrumentSend === "T" &&
        i.walletInstrumentResource.primaryInstrumentReceive === "T" &&
        i.walletInstrumentResource.state === "ENABLED"
    )[0];
  }

  getCardWalletInstrument() {
    const cardList = this._all().filter(r => {
      return (
        r.walletInstrumentResource.walletInstrumentType ===
        _WALLET_INSTRUMENT_TYPE.PREPAID_CARD
      );
    });

    const cardAssociated = cardList.filter(
      card => card.walletInstrumentResource.state === _CARD_STATES.ENABLED
    )[0];
    const cardExpiring = cardList.filter(
      card => card.walletInstrumentResource.state === _CARD_STATES.EXPIRING
    )[0];
    const cardPending = cardList.filter(
      card => card.walletInstrumentResource.state === _CARD_STATES.PENDING
    )[0];
    const cardBlocked = cardList.filter(
      card => card.walletInstrumentResource.state === _CARD_STATES.BLOCKED
    )[0];

    //priorità: Associate, expiring, pending, blocked, deleted, nessuna carta
    const result =
      cardAssociated || cardExpiring || cardPending || cardBlocked || undefined;

    return result;
  }
}

export default new WalletService();
